<template>
  <div>

  </div>
</template>

<script>
  import i18n from './locales'
  
  export default {
    name: 'LoanUpdates',
    i18n,
  }
</script>
